<template>
  <div class="product-list" v-if="products">
    <template v-for="(product, index) in products">
      <div class="border border-dark mb-3" v-if="product && product.isOnSale" :key="`product-list-${index}`">
        <router-link :to="`/w/product/detail/${product.goodsId}`" class="text-decoration-none text-dark">
          <div class="row">
            <div class="col-auto">
              <div class="position-relative overflow-hidden">
                <div class="image" :style="util.getImageStyle(product.goodsImg)"></div>
                <div class="image hover-image position-absolute" :style="util.getImageStyle(product.goodsImg2)" v-if="product.goodsImg2"></div>
                <div class="position-absolute top-0 start-0 d-flex">
                  <tag-promote class="tag" v-if="util.isPromoteProduct(product) && product.promotePrice"/>
                  <template v-else-if="getShopDiscount(product)">
                    <tag-user-rank-discount class="tag" v-if="userRank && (shopVipDiscount === 1 || (shopVipDiscount === 2 && product.isMemberDiscount))"/>
                    <tag-discount class="tag" v-else :discount="getShopDiscount(product)"/>
                  </template>
                  <!--tag-user-rank class="tag" v-else-if="userRank && userRank.discount && userRank.discount < 100"/-->
                  <tag-new class="tag" v-else-if="isNew(product)"/>
                </div>
              </div>
            </div>
            <div class="col pt-2 pb-2 pt-md-3 pb-md-3">
              <div class="name">{{ product.goodsName }}</div>
              <div class="brand">{{ getBrandName(product.brandId) }}</div>
              <div class="desc mt-3" v-html="product.goodsDesc"></div>
              <!-- mobile -->
              <div class="d-block d-md-none" v-if="util.hasCheaperPrice(product, userRank)">
                <span class="price-orig text-secondary text-decoration-line-through" v-show="product.shopPrice !== constant.PRODUCT_PRICE_ASK">{{ util.toPriceFormat(product.marketPrice) }}</span>
                <span class="price loft-text-highlight" v-if="product.shopPrice === constant.PRODUCT_PRICE_ASK">價格電洽</span>
                <span class="price loft-text-highlight" v-else>{{ util.toPriceFormat(util.getGoodsPrice(product, userRank, shopVipDiscount, 0)) }}</span>
              </div>
              <div class="d-block d-md-none price" v-else>{{ util.toPriceFormat(product.marketPrice) }}</div>
            </div>
            <!-- pc -->
            <div class="end-col d-none d-md-block">
              <div class="m-0 p-3 text-end h-100 row flex-column">
                <div class="col-auto">
                  <div v-if="util.hasCheaperPrice(product, userRank)">
                    <span class="price-orig text-secondary text-decoration-line-through" v-show="product.shopPrice !== constant.PRODUCT_PRICE_ASK">{{ util.toPriceFormat(product.marketPrice) }}</span>
                    <span class="price loft-text-highlight" v-if="product.shopPrice === constant.PRODUCT_PRICE_ASK">價格電洽</span>
                    <span class="price loft-text-highlight" v-else>{{ util.toPriceFormat(util.getGoodsPrice(product, userRank, shopVipDiscount, 0)) }}</span>
                  </div>
                  <div class="price" v-else>{{ util.toPriceFormat(product.marketPrice) }}</div>
                </div>
                <div class="col d-flex flex-column justify-content-center">
                  <div class="btn-group-vertical w-100 mt-3" role="group" v-if="product.shopPrice !== constant.PRODUCT_PRICE_ASK">
                    <button class="btn ps-4 pe-4 btn-product-option" data-bs-toggle="modal" data-bs-target="#product-modal" @click.prevent="setSelectedProduct(product)">加入購物車</button>
                    <router-link :to="`/w/product/detail/${product.goodsId}`" class="btn ps-4 pe-4 btn-product-option">顯示更多</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import { mapGetters, mapMutations } from 'vuex'
import TagDiscount from './TagDiscount.vue'
import TagNew from './TagNew.vue'
import TagPromote from './TagPromote.vue'
// import TagUserRank from './TagUserRank.vue'
import TagUserRankDiscount from './TagUserRankDiscount.vue'

export default {
  name: 'ProductList',
  components: {
    TagDiscount,
    TagNew,
    TagPromote,
    // TagUserRank,
    TagUserRankDiscount
  },
  props: {
    products: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'getBrandName',
      'userRank',
      'shopVipDiscount'
    ]),
    constant: function () {
      return constant
    },
    util: function () {
      return util
    }
  },
  methods: {
    ...mapMutations([
      'setSelectedProduct'
    ]),
    getShopDiscount: function (product) {
      var ret = util.getProductDiscount(product)
      if (ret && this.userRank && this.userRank.discount && this.userRank.discount < 100) {
        if (!(this.shopVipDiscount === 1 || (this.shopVipDiscount === 2 && product.isMemberDiscount)) && (100 - this.userRank.discount) > ret) {
          return null
        }
      }
      return ret
    },
    isNew: function (product) {
      var lastMonth = new Date()
      lastMonth.setMilliseconds(0)
      lastMonth.setSeconds(0)
      lastMonth.setMinutes(0)
      lastMonth.setHours(0)
      lastMonth.setMonth(lastMonth.getMonth() - 1)
      return product && product.onSaleDate && product.onSaleDate >= parseInt(lastMonth.getTime() / 1000)
    }
  }
}
</script>

<style scoped>
.image {
  width: 100%;
  padding-bottom: 100%;
  min-width: 256px;
  min-height: 256px;
}
.hover-image {
  top: 0;
  opacity: 0;
  transform: scale(1.1);
  transition: all .5s cubic-bezier(.25,1,.5,1);
  transition-delay: 0ms, 0ms;
}
.hover-image:hover {
  opacity: 1;
  transform: scale(1);
}
.tag {
  margin: 12px 0 0 12px;
}
.brand {
  font-family: 'Noto Serif TC', serif;
  font-size: 1.8rem;
}
.name {
  font-size: 1.3rem;
  font-weight: 500;
}
.desc {
  font-size: 0.9rem;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.desc >>> p {
  margin-bottom: 0px;
}
.link {
  font-size: 0.9rem;
}
.end-col {
  flex: 0 0 auto;
  width: 240px;
}
.price-orig {
  font-size: 0.6rem;
}
.price {
  font-size: 1.1rem;
}
.btn-product-option {
  font-size: 0.6rem;
  border-radius: 0;
  background-color: var(--bg-color);
  border-color: lightgray;
  width: 100%;
}
.btn-product-option:hover {
  border-color: var(--bs-dark);
}
@media screen and (max-width: 767px) {
  .image {
    min-width: 96px;
    min-height: 96px;
  }
  .brand {
    font-size: 1.2rem;
  }
  .name {
    font-size: 1rem;
  }
  .desc {
    display: none;
  }
  .tag {
    margin: 4px 0 0 4px;
    padding: 4px;
    display: inline !important;
    width: unset;
    height: unset;
    font-weight: 500;
    font-size: 12px;
  }
  .tag >>> div {
    display: inline;
    padding: 0 2px;
  }
  .product-list >>> .rounded-circle {
    border-radius: 0 !important;
  }
}
</style>
